import FileModel                   from 'Models/file/FileModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import { IGearNameProps }          from 'modelNames/intervention/GearName';
import InterventionPrivateApiModel from 'modelx/models/abstracts/InterventionPrivateApiModel';

@model.staticLabel('EPI')
@model.urnResource('gear')
@doc.path('/gears/{?id}')
export default class GearModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'archived': '0' | '1';
		'label': string;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'updatedAt': string;
	}> = {};

	@doc.boolean declare archived: boolean;
	@doc.string declare label: string;

	@model.fileResolvable('gear_pictogram')
	public declare pictogram: FileModel;

	public renderName(props?: Omit<IGearNameProps, 'model'>) {
		return super.renderName(props);
	}
}
